import React from "react";
import { TextLink } from "@teamscheme/text-link";

export function NoResultsPlaceholder({
  query,
  clear,
}: {
  query: string;
  clear: () => void;
}) {
  return (
    <div>
      <p>
        Fant ingen treff på "{query}". Prøv å søke på noe annet eller{" "}
        <TextLink onClick={clear}>nullstill søket</TextLink>.
      </p>
    </div>
  );
}
